import Header from "../../components/Header/Header";
import Plano from "../../components/Plano/Plano";
import { SkeletonCard } from "../../components/Skeleton/Skeleton";
import style from "./_planos.module.css";
import { useState } from "react";
import { FaPlay, FaPlus } from "react-icons/fa6";
import { BsBoxArrowInDown } from "react-icons/bs";
import "bootstrap/dist/css/bootstrap.min.css";
import { toast } from "react-toastify";
import PlanoAPI from "../../services/PlanoService";
import { getApiError } from "../../services/client";
import { registrarEvento } from "../../utils/analytics";
import { LuGraduationCap, LuArchive } from "react-icons/lu";
import { BsRobot } from "react-icons/bs";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import ModalExcluirPlano from "../../components/Modais/Planos/ModalExcluirPlano";
import ModalLancarHoras from "../../components/Modais/Planos/ModalLancarHoras";
import ModalConfigurarPlano from "../../components/Modais/Planos/ModalConfigurarPlano";
import ModalCriarPlano from "../../components/Modais/Planos/ModalCriarPlano";
import ModalVisualizarPlano from "../../components/Modais/Planos/ModalVisualizarPlano";
import ModalCriarPlanoIA from "../../components/Modais/Planos/ModalCriarPlanoIA";
import ModalCompartilharPlano from "../../components/Modais/Planos/ModalCompartilharPlano";
import ModalResgatarPlano from "../../components/Modais/Planos/ModalResgatarPlano";
import ModalGrupoProgresso from "../../components/Modais/Planos/ModalGrupoProgresso";
import IAAPI from "../../services/IAService";
import Tour, { useTour } from "../../components/Tour/Tour";

const TINTA_MODAL = "rgba(9, 20, 62, 0.45)";

const mapPlanoBackend = (plano) => ({
  planoId: plano.planoId,
  titulo: plano.titulo,
  objetivo: plano.objetivo,
  dataInicio: plano.dataInicio,
  dataFim: plano.dataFim,
  horasPorSemana: plano.horasPorSemana,
  ativo: plano.ativo,
  grupoId: plano.grupoId ?? null,
  materias: (plano.planoMaterias ?? []).map((pm) => ({
    planoMateriaId: pm.planoMateriaId,
    materiaId: pm.materiaId,
    nome: pm.materia.nome,
    cor: pm.materia.cor,
    horasTotais: pm.horasTotais,
    horasConcluidas: pm.horasConcluidas,
    topicos: pm.topicos ?? [],
  })),
});

function Planos() {
  const queryClient = useQueryClient();

  const hoje = new Date().toISOString().split("T")[0];

  const [mostrarPlano, setMostrarPlano] = useState(false);
  const [mostrarCriarPlano, setMostrarCriarPlano] = useState(false);
  const [mostrarConfigurar, setMostrarConfigurar] = useState(false);
  const [mostrarHoras, setMostrarHoras] = useState(false);
  const [mostrarExcluir, setMostrarExcluir] = useState(false);
  const [mostrarIa, setMostrarIa] = useState(false);
  const [mostrarCompartilhar, setMostrarCompartilhar] = useState(false);
  const [mostrarResgatar, setMostrarResgatar] = useState(false);
  const [mostrarGrupo, setMostrarGrupo] = useState(false);

  const [chaveCompartilhada, setChaveCompartilhada] = useState("");
  const [grupoIdAtual, setGrupoIdAtual] = useState(null);
  const [chaveResgate, setChaveResgate] = useState("");
  const [grupoData, setGrupoData] = useState(null);
  const [carregandoGrupo, setCarregandoGrupo] = useState(false);

  const [viewingPlanoId, setViewingPlanoId] = useState(null);
  const [configurandoPlanoId, setConfigurandoPlanoId] = useState(null);

  const [planoParaExcluir, setPlanoParaExcluir] = useState(null);

  const [titulo, setTitulo] = useState("");
  const [objetivo, setObjetivo] = useState("");
  const [dataInicio, setDataInicio] = useState("");
  const [dataFim, setDataFim] = useState("");
  const [horasSemana, setHorasSemana] = useState("");

  const [materialParaLancar, setMaterialParaLancar] = useState(null);
  const [loading, setLoading] = useState(false);

  const LIMITE_DIARIO = 20;

  const { data: planosList = [], isPending: carregandoPlanos } = useQuery({
    queryKey: ["planos"],
    queryFn: async () => {
      const resposta = await PlanoAPI.Listar5();
      return resposta.map(mapPlanoBackend);
    },
    staleTime: Infinity,
    onError: () => toast.error("Erro ao carregar planos"),
  });

  const invalidarPlanos = () =>
    queryClient.invalidateQueries({
      queryKey: ["planos"],
      refetchType: "active",
    });

  const invalidarInicio = () => {
    queryClient.invalidateQueries({
      queryKey: ["planoAtivo"],
      refetchType: "active",
    });
    queryClient.invalidateQueries({
      queryKey: ["resumo"],
      refetchType: "active",
    });
    queryClient.invalidateQueries({
      queryKey: ["totalSimulados"],
      refetchType: "active",
    });
    queryClient.invalidateQueries({
      queryKey: ["comparacaoHoras"],
      refetchType: "active",
    });
    queryClient.invalidateQueries({
      queryKey: ["dashboardDesempenho"],
      refetchType: "active",
    });
  };

  const planoAtivo = planosList.find((p) => p.ativo) ?? null;
  const planoVisualizado =
    planosList.find((p) => p.planoId === viewingPlanoId) ?? null;
  const planoParaConfigurar =
    planosList.find((p) => p.planoId === configurandoPlanoId) ?? null;

  const abrirCriarPlano = () => {
    if (planosList.length >= 5) {
      toast.warn("Você já atingiu o limite de 5 planos.");
      return;
    }
    setTitulo("");
    setObjetivo("");
    setDataInicio("");
    setDataFim("");
    setHorasSemana("");
    setMostrarCriarPlano(true);
  };

  const abrirPlanoIa = () => {
    if (planosList.length >= 5) {
      toast.warn("Você já atingiu o limite de 5 planos.");
      return;
    }
    setTitulo("");
    setObjetivo("");
    setDataInicio("");
    setDataFim("");
    setHorasSemana("");
    setMostrarIa(true);
  };

  const diferencaEmDias = (inicio, fim) => {
    const a = new Date(inicio);
    const b = new Date(fim);
    return Math.ceil((b.getTime() - a.getTime()) / (1000 * 60 * 60 * 24));
  };

  const criarPlano = async (planoIA) => {
    if (!titulo || !objetivo) return toast.warn("Preencha todos os campos!");

    if (planoIA && (!horasSemana || horasSemana <= 0))
      return toast.warn("Informe a carga horária semanal.");

    if (!dataInicio || !dataFim)
      return toast.warn("Preencha as datas de início e fim.");
    if (dataFim < dataInicio)
      return toast.warn("Data final não pode ser anterior à data de início");
    const duracao = diferencaEmDias(dataInicio, dataFim);
    if (duracao < 14)
      return toast.warn("O plano deve ter duração mínima de 2 semanas.");
    if (duracao > 365 * 5)
      return toast.warn("O plano não pode ter duração maior que 5 anos.");

    if (planoIA) {
      try {
        setLoading(true);
        const planoCriado = await IAAPI.CriarPlano({
          titulo,
          objetivo,
          horasPorSemana: Number(horasSemana),
          dataInicio: new Date(dataInicio + "T00:00:00").toISOString(),
          dataFim: new Date(dataFim + "T00:00:00").toISOString(),
        });

        const novoPlano = mapPlanoBackend({
          ...planoCriado,
          planoMaterias: planoCriado.planoMaterias ?? [],
        });
        queryClient.setQueryData(["planos"], (old = []) => [...old, novoPlano]);

        setMostrarIa(false);
        invalidarPlanos();
        invalidarInicio();
        registrarEvento("plano_criado", { viaIa: true });
        toast.success("Plano criado e ativado!");
      } catch (erro) {
        toast.error(getApiError(erro, "Erro ao criar plano com IA"));
      } finally {
        setLoading(false);
      }
      return;
    }

    try {
      setLoading(true);
      const planoCriado = await PlanoAPI.Criar({
        titulo,
        objetivo,
        dataInicio: new Date(dataInicio + "T00:00:00").toISOString(),
        dataFim: new Date(dataFim + "T00:00:00").toISOString(),
        horasPorSemana: Number(horasSemana) || 0,
        ativo: true,
      });

      await PlanoAPI.AtivarPlano(planoCriado.planoId);

      const novoPlano = mapPlanoBackend({ ...planoCriado, planoMaterias: [] });
      queryClient.setQueryData(["planos"], (old = []) => [...old, novoPlano]);

      setConfigurandoPlanoId(planoCriado.planoId);
      setMostrarCriarPlano(false);
      setMostrarConfigurar(true);

      invalidarPlanos();
      invalidarInicio();
      registrarEvento("plano_criado", { viaIa: false });
      toast.success("Plano criado e ativado!");
    } catch (erro) {
      toast.error(getApiError(erro, "Erro ao criar plano"));
    } finally {
      setLoading(false);
    }
  };

  // ── Visualização ─────────────────────────────────────────────────────────

  const handleClickPlano = (planoId) => {
    setViewingPlanoId(planoId);
    setMostrarPlano(true);
  };

  // ── Configuração ──────────────────────────────────────────────────────────

  const abrirConfigurar = () => {
    setConfigurandoPlanoId(planoVisualizado.planoId);
    setMostrarPlano(false);
    setMostrarConfigurar(true);
  };

  const salvarPlano = async ({ titulo, objetivo, dataFim, horasPorSemana }) => {
    try {
      setLoading(true);
      await PlanoAPI.Atualizar({
        planoId: planoParaConfigurar.planoId,
        titulo,
        objetivo,
        dataFim: dataFim ? new Date(dataFim + "T00:00:00").toISOString() : null,
        horasPorSemana,
      });
      toast.success("Plano salvo!");
      setMostrarConfigurar(false);
      invalidarPlanos();
      invalidarInicio();
    } catch (erro) {
      toast.error(getApiError(erro, "Erro ao salvar plano"));
    } finally {
      setLoading(false);
    }
  };

  const handleAtivarPlanoFromConfigurar = async () => {
    try {
      await PlanoAPI.AtivarPlano(planoParaConfigurar.planoId);
      setMostrarConfigurar(false);
      invalidarPlanos();
      invalidarInicio();
      toast.success("Plano ativado");
    } catch (erro) {
      toast.error(getApiError(erro, "Erro ao ativar plano"));
    }
  };

  // ── Lançar horas ──────────────────────────────────────────────────────────

  const abrirLancamentoHoras = (pm) => {
    setMaterialParaLancar(pm ?? null);
    setMostrarHoras(true);
  };

  const lancarHoras = async ({ planoMateriaId, horas }) => {
    if (!horas || horas <= 0) return toast.warn("Informe um valor válido");

    try {
      setLoading(true);
      const comparacao = await PlanoAPI.CompararHoras();
      const horasHoje = comparacao.horasHoje;
      if (horasHoje + Number(horas) > LIMITE_DIARIO) {
        toast.warn(
          `Limite diário de ${LIMITE_DIARIO}h atingido. Você já lançou ${horasHoje}h hoje.`,
        );
        return;
      }
      await PlanoAPI.LancarHoras(planoMateriaId, Number(horas));
      registrarEvento("horas_lancadas", { horas: Number(horas) });
      toast.success("Horas lançadas");
      setMostrarHoras(false);
      queryClient.invalidateQueries({ queryKey: ["resumo"] });
      queryClient.invalidateQueries({ queryKey: ["comparacaoHoras"] });
      queryClient.invalidateQueries({ queryKey: ["planoAtivo"] });
      queryClient.invalidateQueries({ queryKey: ["dashboardDesempenho"] });
      invalidarPlanos();
    } catch (erro) {
      toast.error(getApiError(erro, "Erro ao lançar horas"));
    } finally {
      setLoading(false);
    }
  };

  // ── Exclusão ──────────────────────────────────────────────────────────────

  const handleExcluirPlano = async () => {
    try {
      setLoading(true);
      await PlanoAPI.Excluir(planoParaExcluir.planoId);
      toast.success("Plano excluído");

      setMostrarExcluir(false);
      setMostrarPlano(false);
      // fix 1: reset por ID
      setViewingPlanoId(null);

      // fix 3: sem setQueryData otimista — evita race condition com o refetch imediato
      invalidarPlanos();
      invalidarInicio();
    } catch (erro) {
      toast.error(getApiError(erro, "Erro ao excluir plano"));
    } finally {
      setLoading(false);
    }
  };

  // ── Compartilhamento ──────────────────────────────────────────────────────

  const handleCompartilhar = async () => {
    if (!planoVisualizado) return;
    try {
      setLoading(true);
      const resultado = await PlanoAPI.Compartilhar(planoVisualizado.planoId);
      setChaveCompartilhada(resultado.chave);
      setGrupoIdAtual(resultado.grupoId);
      setMostrarPlano(false);
      setMostrarCompartilhar(true);
      registrarEvento("plano_compartilhado", {});
      invalidarPlanos();
    } catch (erro) {
      toast.error(getApiError(erro, "Erro ao compartilhar plano"));
    } finally {
      setLoading(false);
    }
  };

  const abrirResgatar = () => {
    setChaveResgate("");
    setMostrarResgatar(true);
  };

  const handleResgatar = async () => {
    const chave = chaveResgate.trim();
    if (!chave) return toast.warn("Informe a chave de compartilhamento.");
    if (planosList.length >= 5) {
      toast.warn("Você já atingiu o limite de 5 planos.");
      return;
    }

    try {
      setLoading(true);
      await PlanoAPI.Resgatar(chave);
      setMostrarResgatar(false);
      setChaveResgate("");
      invalidarPlanos();
      invalidarInicio();
      registrarEvento("plano_resgatado", {});
      toast.success("Plano resgatado!");
    } catch (erro) {
      toast.error(getApiError(erro, "Erro ao resgatar plano"));
    } finally {
      setLoading(false);
    }
  };

  const handleAbrirGrupo = async (grupoId) => {
    if (!grupoId) return;
    setMostrarCompartilhar(false);
    setMostrarPlano(false);
    setGrupoData(null);
    setCarregandoGrupo(true);
    setMostrarGrupo(true);
    try {
      const dados = await PlanoAPI.ObterGrupo(grupoId);
      setGrupoData(dados);
    } catch (erro) {
      toast.error(getApiError(erro, "Erro ao carregar o grupo"));
      setMostrarGrupo(false);
    } finally {
      setCarregandoGrupo(false);
    }
  };

  const planosInativos = planosList.filter((p) => !p.ativo);

  const { ativo: tourAtivo, encerrar: encerrarTour } = useTour(
    "planos",
    !carregandoPlanos,
  );

  const passosTour = [
    {
      alvo: '[data-tour="planos-criar"]',
      lado: "baixo",
      titulo: "Seu plano de estudos",
      texto:
        "O plano guarda suas matérias, tópicos e carga horária. Aqui você monta um do zero, no seu ritmo.",
      raio: 10,
    },
    {
      alvo: '[data-tour="planos-resgatar"]',
      lado: "baixo",
      titulo: "Estudando com alguém?",
      texto:
        "Se um amigo compartilhou o plano dele, cole a chave aqui e vocês acompanham o progresso juntos.",
      raio: 10,
    },
    {
      alvo: '[data-tour="planos-ia"]',
      lado: "esquerda",
      titulo: "O caminho mais rápido",
      texto:
        "A IA monta o plano inteiro pra você: matérias, tópicos e horas distribuídas até a data da prova.",
      raio: 999,
      acao: { texto: "Bora criar", executar: abrirPlanoIa },
    },
    {
      alvo: '[data-tour="plano-ia-objetivo"]',
      lado: "direita",
      titulo: "Capriche no objetivo",
      texto:
        'Quanto mais específico, melhor o plano. Ex.: "Medicina na UFPE, tenho dificuldade em exatas".',
      tinta: TINTA_MODAL,
      raio: 10,
      semVoltar: true,
    },
    {
      alvo: '[data-tour="plano-ia-horas"]',
      lado: "direita",
      titulo: "Seja realista nas horas",
      texto:
        "É a partir daqui que a IA distribui a carga entre as matérias. Prefira um ritmo que você consiga manter.",
      tinta: TINTA_MODAL,
      raio: 10,
    },
    {
      alvo: '[data-tour="plano-ia-periodo"]',
      lado: "cima",
      titulo: "Do começo até a prova",
      texto:
        "A data final normalmente é o dia do seu vestibular — o cronograma é calculado até lá.",
      tinta: TINTA_MODAL,
      raio: 10,
    },
    {
      alvo: '[data-tour="plano-ia-gerar"]',
      lado: "cima",
      titulo: "E é só isso",
      texto:
        "Clique em Gerar plano e em alguns segundos ele aparece aqui, pronto pra você acompanhar.",
      tinta: TINTA_MODAL,
      raio: 10,
    },
  ];

  return (
    <div className={`page ${style.pagePlanos}`}>
      <Header />
      <Tour
        id="planos"
        passos={passosTour}
        ativo={tourAtivo}
        aoEncerrar={encerrarTour}
      />

      <div className={style.fab_container}>
        <button
          className={style.fab}
          data-tour="planos-ia"
          onClick={abrirPlanoIa}
          title="Gerar plano com IA"
        >
          <BsRobot className={style.icon} />
          <span className={style.fabTexto}>Gerar com IA</span>
        </button>
      </div>

      <div className={style.container}>
        <header className={style.pageHead}>
          <div className={style.pageHeadText}>
            <span className="eyebrow">Sua jornada</span>
            <h1 className={style.pageTitle}>Planos de estudo</h1>
            <p className={style.pageSub}>
              Organize suas matérias, defina metas e acompanhe seu progresso
              rumo ao seu objetivo.
            </p>
          </div>
          <div className={style.pageHeadAcoes}>
            <span className={style.heroIndice}>03 / Planos</span>
            <button
              className={style.botaoNovo}
              data-tour="planos-resgatar"
              onClick={abrirResgatar}
            >
              <BsBoxArrowInDown />
              <span className={style.botaoNovoTexto}>Resgatar</span>
            </button>
            {planosList.length > 0 && (
              <button
                className={style.botaoNovo}
                data-tour="planos-criar"
                onClick={abrirCriarPlano}
              >
                <FaPlus />
                <span className={style.botaoNovoTexto}>Novo plano</span>
              </button>
            )}
          </div>
        </header>

        {carregandoPlanos ? (
          <section className={style.secao}>
            <SkeletonCard lines={3} grande />
          </section>
        ) : planosList.length === 0 ? (
          <div className={style.vazio}>
            <div className={style.vazioIcon}>
              <LuGraduationCap />
            </div>
            <h3>Nenhum plano ainda</h3>
            <p>Comece criando seu primeiro plano de estudos.</p>
            <button
              className={style.botaoCriarVazio}
              data-tour="planos-criar"
              onClick={abrirCriarPlano}
            >
              <FaPlus /> Criar plano
            </button>
          </div>
        ) : (
          <>
            {planoAtivo && (
              <section className={style.secao}>
                <Plano
                  titulo={planoAtivo.titulo}
                  objetivo={planoAtivo.objetivo}
                  ativo
                  materias={planoAtivo.materias}
                  botao={
                    <button
                      className={`${style.botao_exibir} ${style.botao_exibirAtivo}`}
                      onClick={() => handleClickPlano(planoAtivo.planoId)}
                    >
                      <FaPlay /> Visualizar plano
                    </button>
                  }
                />
              </section>
            )}

            {planosInativos.length > 0 && (
              <section className={style.secao}>
                <div className={style.ledger}>
                  <div className={style.panelHead}>
                    <div className={style.panelTitulo}>
                      <span className={style.panelIcone}>
                        <LuArchive />
                      </span>
                      <div>
                        <h3>Outros planos</h3>
                        <span>Arquivados — ative quando quiser retomar</span>
                      </div>
                    </div>
                    <span className={style.panelBadge}>
                      {planosInativos.length}{" "}
                      {planosInativos.length === 1 ? "plano" : "planos"}
                    </span>
                  </div>
                  <div className={style.ledgerHead}>
                    <span>Plano</span>
                    <span>Matérias</span>
                    <span>Horas</span>
                    <span>Progresso</span>
                    <span aria-hidden="true" />
                  </div>
                  {planosInativos.map((plano) => {
                    const horasTotais = plano.materias.reduce(
                      (acc, m) => acc + (m.horasTotais || 0),
                      0,
                    );
                    const horasConcluidas = plano.materias.reduce(
                      (acc, m) => acc + (m.horasConcluidas || 0),
                      0,
                    );
                    const pct =
                      horasTotais > 0
                        ? Math.round((horasConcluidas / horasTotais) * 100)
                        : 0;
                    return (
                      <button
                        type="button"
                        key={plano.planoId}
                        className={style.ledgerRow}
                        onClick={() => handleClickPlano(plano.planoId)}
                      >
                        <span className={style.ledgerTitulo}>
                          {plano.titulo}
                        </span>
                        <span className={style.ledgerMeta}>
                          {plano.materias.length}
                        </span>
                        <span className={style.ledgerMeta}>
                          {horasConcluidas}/{horasTotais}h
                        </span>
                        <span className={style.ledgerProg}>
                          <span className={style.ledgerTrack}>
                            <span
                              className={style.ledgerFill}
                              style={{ width: `${pct}%` }}
                            />
                          </span>
                          <em>{pct}%</em>
                        </span>
                        <span className={style.ledgerLink}>
                          <FaPlay /> Abrir
                        </span>
                      </button>
                    );
                  })}
                </div>
              </section>
            )}
          </>
        )}
      </div>

      <ModalVisualizarPlano
        show={mostrarPlano}
        onHide={() => setMostrarPlano(false)}
        plano={planoVisualizado}
        onConfigurar={abrirConfigurar}
        onLancarHoras={abrirLancamentoHoras}
        onCompartilhar={handleCompartilhar}
        onVerGrupo={handleAbrirGrupo}
      />

      <ModalConfigurarPlano
        show={mostrarConfigurar}
        onHide={() => setMostrarConfigurar(false)}
        loading={loading}
        plano={planoParaConfigurar}
        onSalvar={salvarPlano}
        onExcluir={() => {
          setMostrarConfigurar(false);
          setPlanoParaExcluir(planoParaConfigurar);
          setMostrarExcluir(true);
        }}
        onAtivarPlano={handleAtivarPlanoFromConfigurar}
        isAtivo={planoParaConfigurar?.ativo ?? false}
      />

      <ModalLancarHoras
        show={mostrarHoras}
        onHide={() => setMostrarHoras(false)}
        loading={loading}
        plano={planoVisualizado}
        onLancar={lancarHoras}
        initialPlanoMateriaId={materialParaLancar?.planoMateriaId ?? ""}
      />

      <ModalCriarPlano
        show={mostrarCriarPlano}
        onHide={() => setMostrarCriarPlano(false)}
        titulo={titulo}
        setTitulo={setTitulo}
        objetivo={objetivo}
        setObjetivo={setObjetivo}
        dataInicio={dataInicio}
        setDataInicio={setDataInicio}
        dataFim={dataFim}
        setDataFim={setDataFim}
        hoje={hoje}
        onCriar={() => criarPlano(false)}
        loading={loading}
      />

      <ModalCriarPlanoIA
        show={mostrarIa}
        onHide={() => setMostrarIa(false)}
        titulo={titulo}
        setTitulo={setTitulo}
        objetivo={objetivo}
        setObjetivo={setObjetivo}
        horasSemana={horasSemana}
        setHorasSemana={setHorasSemana}
        dataInicio={dataInicio}
        setDataInicio={setDataInicio}
        dataFim={dataFim}
        setDataFim={setDataFim}
        hoje={hoje}
        onCriar={() => criarPlano(true)}
        loading={loading}
      />

      <ModalExcluirPlano
        show={mostrarExcluir}
        onHide={() => setMostrarExcluir(false)}
        planoParaExcluir={planoParaExcluir}
        onExcluir={handleExcluirPlano}
        loading={loading}
      />

      <ModalCompartilharPlano
        show={mostrarCompartilhar}
        onHide={() => setMostrarCompartilhar(false)}
        chave={chaveCompartilhada}
        onVerGrupo={
          grupoIdAtual ? () => handleAbrirGrupo(grupoIdAtual) : undefined
        }
      />

      <ModalResgatarPlano
        show={mostrarResgatar}
        onHide={() => setMostrarResgatar(false)}
        chave={chaveResgate}
        setChave={setChaveResgate}
        onResgatar={handleResgatar}
        loading={loading}
      />

      <ModalGrupoProgresso
        show={mostrarGrupo}
        onHide={() => setMostrarGrupo(false)}
        grupo={grupoData}
        loading={carregandoGrupo}
      />
    </div>
  );
}

export default Planos;
